import classNames from 'classnames';
import Link from 'components/gruenland/atoms/link';
import Typography from 'components/gruenland/atoms/typography';
import { useEffect, useState } from 'react';
import { Category } from 'shared/types/product/Category';

export interface Props {
  show: boolean;
  link: Category;
  updateSubMenu: () => void;
}

const HeaderNavigationButtonDesktop: React.FC<Props> = ({ show, link, updateSubMenu }) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  if (!isLoaded) return <></>;

  return (
    <div onClick={updateSubMenu} className="h-[52px] py-3">
      <Link
        link={link?._url}
        title={link?.name}
        className={classNames('relative flex border-primary-yellow py-1 hover:border-b-4', {
          'border-b-4': show,
        })}
      >
        <Typography as="span" className="text-[18px]/[22.68px] font-medium">
          {link?.name}
        </Typography>
        {/* {link?.descendants && link?.descendants.length > 0 && (
          <ChevronDownIcon className="ml-[10px] w-4 text-secondary-black" />
        )} */}
      </Link>
    </div>
  );
};
export default HeaderNavigationButtonDesktop;
